import Action from './Action';
import Status from './Status';

export default [
	{ title: 'Customer Name', field: 'cust_name' },
	{ title: 'Mandate Type', field: 'mandate_type' },
	{ title: 'UMRN', field: 'umrn' },
	{ title: 'Mandate Amount', field: 'mandate_amt' },
	{ title: 'Bank Name', field: 'bank_name' },
	{ title: 'IFSC', field: 'ifsc' },
	{ title: 'Account Type', field: 'acc_type' },
	{ title: 'Account Number', field: 'acc_no' },
	{ title: 'Status', field: 'mandate_status', component: Status },
	{ title: 'Action', field: '', component: Action },
];
